import React from 'react';
import { Box } from '@mui/material';
import LeftSection from '../login/leftSection';
import SignupRightSection from './SignupRightSection';
import { QA_QUOTES } from './constants';

export default function SignupPage() {
  return (
    <Box display="flex" height="100vh" bgcolor="#0F172A" overflow="hidden">
      <LeftSection qaQuotes={QA_QUOTES} />
      <SignupRightSection />
    </Box>
  );
}
